const formReset = () => {
 const SELECTOR_RESET_BUTTON = `.btn-form-reset`;

 const resetSelect = (targetForm) => {
 targetForm.querySelectorAll(`.select`).forEach((select) => {
 select.selectedIndex = 0;
 });
 };

 const resetTextfield = (targetForm) => {
 targetForm.querySelectorAll(`.textfield`).forEach((input) => {
 input.value = ``;
 });
 };

 const resetCheck = (targetForm) => {
 const radioGroups = new Set();

 targetForm.querySelectorAll(`.check[type="checkbox"]`).forEach((check) => {
 check.checked = false;
 });

 targetForm.querySelectorAll(`.check[type="radio"]`).forEach((radio) => {
 radio.checked = false;

 if (!radioGroups.has(radio.name)) {
 radio.checked = true;
 radioGroups.add(radio.name);
 }
 });
 };

 const resetForm = (targetForm) => {
 resetSelect(targetForm);
 resetTextfield(targetForm);
 resetCheck(targetForm);
 };

 const handleClick = (event) => {
 const target = event.target;
 const targetForm = target?.closest(`form`);

 if (!targetForm || !target.closest(SELECTOR_RESET_BUTTON)) return;

 if (target.closest(SELECTOR_RESET_BUTTON).type === `reset`)
 event.preventDefault();

 resetForm(targetForm);
 };

 const initialize = () => {
 document.body.addEventListener(`click`, handleClick);
 };

 initialize();

 formReset.cleanup = () => {
 document.body.removeEventListener(`click`, handleClick);
 };
};

export default formReset;
